import { typeKeys } from './config';

export const getType = (type) =>
  type === typeKeys.primary ? typeKeys.primary : 'default';
